import React from 'react';
import { useNavigate } from 'react-router-dom';
import { UserCircle } from 'lucide-react';
import { useSession } from '../contexts/SessionContext';

interface UserMenuProps {
  email: string;
  className?: string;
  /** When provided (e.g. inside an extranet), opens Settings the same way as the sidebar; otherwise navigates to /settings */
  onOpenSettings?: () => void;
}

export function UserMenu({ email, className, onOpenSettings }: UserMenuProps) {
  const navigate = useNavigate();
  const { user } = useSession();

  const handleClick = () => {
    if (!user) return;
    if (onOpenSettings) {
      onOpenSettings();
    } else {
      navigate('/settings');
    }
  };

  return (
    <button
      onClick={handleClick}
      className={className || "flex items-center space-x-2 text-gray-600 hover:text-gray-900 transition-colors"}
    >
      <UserCircle className="h-6 w-6" />
      <span className="text-sm font-medium flex-1 text-left truncate">{email}</span>
    </button>
  );
}